import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DimDatatableColumn } from '@models';
import { MessageService } from '@services';
import { ItensServiceV2 } from '@servicesv2';
import { getDeviceType, getErrorMessage } from '@utils';
import { ModalCadastroComponent } from '../../shared/modal-cadastro/modal-cadastro.component';
import { ConsultaRapidaSaldoPorAlmoxarifadoViewModel } from 'models/itens/ConsultaRapidaItemResponseViewModel';

@Component({
  selector: 'app-consulta-rapida-produtos',
  templateUrl: './consulta-rapida-produtos.component.html',
  styleUrls: ['./consulta-rapida-produtos.component.css']
})
export class ConsultaRapidaProdutosComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild("baseModal", { static: true }) baseModal;
  @Input() abrirModal: any = null;
  form: FormGroup;
  dataAtual: Date = new Date();
  loading: any = {
    request: false,
  };
  tabelasPrecos: any[] = [];
  colunas: DimDatatableColumn[] = [
    { label: 'Tabela', col: 'nome', hide: false },
    { label: 'Preço', col: 'preco', format: (preco: number) => `R$ ${preco.toFixed(2)}` }
  ]
  colunasAlmoxarifados: DimDatatableColumn[] = [
    { label: 'Almoxarifado', col: 'almoxarifado', hide: false },
    { label: 'Saldo', col: 'saldo', hide: false },
  ];
  almoxarifados: ConsultaRapidaSaldoPorAlmoxarifadoViewModel[] = null;

  constructor(
    private itensService: ItensServiceV2,
    private messageService: MessageService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      produtoId: new FormControl(null),
      unidadeMedida: new FormControl(null),
      saldoTotal: new FormControl(null),
      precoSemTabela: new FormControl(null),
      almoxarifadoPadrao: new FormControl(null),
      linhaDeProduto: new FormControl(null),
      estoqueMinimo: new FormControl(null),
    });
  }

  public show(): void {
    this.baseModal.show();
  }

  get DeviceType() {
    return getDeviceType();
  }

  async produtoChanged(produto: any) {
    if (!produto) {
      this.form.reset();
      this.tabelasPrecos = [];
      this.almoxarifados = [];
      return;
    }

    try {
      this.loading.request = true;
      const res = await this.itensService.consultaRapidaItem(produto.id);
      const saldoTotalCalculado = res.saldosPorAlmoxarifado?.reduce(
        (acc, cur) => acc + (Number(cur.saldo) || 0), 0) ?? 0;

      this.form.patchValue({
        unidadeMedida: res.unidadeMedida,
        precoSemTabela: res.precoSemTabela,
        saldoTotal: saldoTotalCalculado,
        almoxarifadoPadrao: res.almoxarifadoPadrao,
        linhaDeProduto: res.linhaDeProduto,
        estoqueMinimo: res.estoqueMinimo,
      });

      this.tabelasPrecos = res.tabelasPreco;
      this.almoxarifados = res.saldosPorAlmoxarifado;
    } catch (error) {
      console.error(error);
      this.messageService.error(getErrorMessage(error));
    } finally {
      this.loading.request = false;
    }
  }

  voltar() {
    this.baseModal.hide();
  }
}
